<template>
  <div>
    <b-card :hidden="!modalShow"
            class="cs-cookie-position w-100"
            body-bg-variant="light">
      <b-container>
        <b-row>
          <span v-html="getIntroLayerDescriptionText()">
          </span>
        </b-row>
        <learn-more-section v-if="!introLayer"
                            :content="cookiePolicyContent.learnMoreLayer"
                            :analytics="analytics"
                            @updateAnalytical="onSetAnalyticalValue"
        />
        <b-row align-h="end">
          <footer-btn :content="cookiePolicyContent"
                      :is-intro-layer="introLayer"
                      @setCookie="onSetCookie"
                      @learnMore="onLearnMore"
          />
        </b-row>
      </b-container>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { replaceContentPlaceholder } from '@/utils/content';
import { dealWithAnalyticToolsDuePolicy } from '@/utils/analytic-tools';
import LearnMoreSection from '@/components/cookie-policy/LearnMoreSection.vue';
import FooterBtn from '@/components/cookie-policy/FooterBtn.vue';

export default {
  name: 'CookieConsent',
  components: { FooterBtn, LearnMoreSection },
  data() {
    return {
      modalShow: false,
      introLayer: true,
      analytics: true,
    };
  },
  created() {
    this.$store.dispatch('content/loadContentForView', 'cookiePolicy');
  },
  computed: {
    ...mapGetters({
      cookiePolicyContent: 'content/getCookiePolicyContent',
    }),
  },
  methods: {
    checkIfUserAgreedToCookiePolicy() {
      const cookieConsent = this.$cookies.get('cookie-consent');
      if (cookieConsent === null) {
        this.modalShow = true;
      } else {
        dealWithAnalyticToolsDuePolicy(cookieConsent);
      }
    },
    onSetCookie() {
      this.$cookies.set('cookie-consent', {
        essentialsCookies: true,
        analyticsCookies: this.analytics,
      });
      this.modalShow = false;
    },
    getIntroLayerDescriptionText() {
      return replaceContentPlaceholder(this.cookiePolicyContent.introLayer.description,
        `<b-link href="#privacy-policy">
                ${this.cookiePolicyContent.introLayer.descriptionArgument1}
                </b-link>`);
    },
    onLearnMore() {
      this.introLayer = false;
    },
    onSetAnalyticalValue(value) {
      this.analytics = value;
    },
  },
};
</script>

<style scoped lang="scss">
/deep/ .cs-cookie-position {
  position:fixed;
  bottom:0;
  background-color: $brandSecondaryColor !important;
  font-weight: $brandSubTitleWeight;
  font-size: $brandCookiePolicyFontSize;
}
</style>
